import { useParams } from "react-router-dom";

export const useStudentId = () => {
  const params = useParams();
  if(params.studentId) {
    return params.studentId;
  } 
  return null
}